import styled from 'styled-components';
const FixedWidthEnrollmentFilterWrapper = styled.div.withConfig({
  displayName: "FixedWidthEnrollmentFilterWrapper",
  componentId: "qk8yze-0"
})(["width:350px;"]);
export default FixedWidthEnrollmentFilterWrapper;